const API_URL = `${import.meta.env.VITE_CC_API_URL}/v1/tools`

export interface DriveItem {
  name: string
  id: string
  size?: number
  created_at?: string
  updated_at?: string
  metadata?: Record<string, any>
  url?: string
  mimeType?: string
  path: string
}

export interface ListParams {
  path?: string
  limit?: number
  offset?: number
  sortBy?: 'name' | 'created_at' | 'updated_at' | 'size'
  sortOrder?: 'asc' | 'desc'
  search?: string
}

export interface ListResponse {
  success: boolean
  data: {
    items: DriveItem[]
    totalCount: number
  }
}

export const listDriveContents = async (token: string, params: ListParams = {}) => {
  const queryParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value) queryParams.append(key, value.toString())
  })

  const response = await fetch(`${API_URL}/knowledge-base/drive?${queryParams}`, {
    headers: { Authorization: `Bearer ${token}` }
  })
  return response.json() as Promise<ListResponse>
}

export const createFolder = async (token: string, parentPath: string, name: string) => {
  if (!name) throw new Error('Folder name is required')
  
  const response = await fetch(`${API_URL}/knowledge-base/drive/folder`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      path: parentPath,
      name: name
    })
  })
  return response.json() as Promise<{ success: boolean; data: DriveItem }>
}

export const moveItem = async (token: string, sourcePath: string, destinationPath: string) => {
  const response = await fetch(`${API_URL}/knowledge-base/drive`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ sourcePath, destinationPath, type: 'move' })
  })
  return response.json()
}

export const getItemDetails = async (token: string, path: string): Promise<{ success: boolean; data: DriveItem }> => {
  const queryParams = new URLSearchParams({ path })
  const response = await fetch(`${API_URL}/knowledge-base/drive?${queryParams}`, {
    headers: { Authorization: `Bearer ${token}` }
  })
  return response.json()
}

export const uploadFile = async (token: string, file: File, path: string) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('path', path)

  const response = await fetch(`${API_URL}/knowledge-base/drive/upload`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData
  })
  return response.json() as Promise<{
    success: boolean;
    data: {
      path: string;
      url: string;
    }
  }>
}
